/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TermsOfUseImport } from './routes/terms-of-use'
import { Route as PrivacyPolicyImport } from './routes/privacy-policy'
import { Route as ContactSupportImport } from './routes/contact-support'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as IndexImport } from './routes/index'
import { Route as VerifyEmailIndexImport } from './routes/verify-email/index'
import { Route as TryScreenerIndexImport } from './routes/try-screener/index'
import { Route as SignInIndexImport } from './routes/sign-in/index'
import { Route as LoginIndexImport } from './routes/login/index'
import { Route as ForgotPasswordIndexImport } from './routes/forgot-password/index'
import { Route as PasswordSetupAuthTokenImport } from './routes/password-setup/$authToken'
import { Route as PasswordChangeAuthTokenImport } from './routes/password-change/$authToken'
import { Route as CreatorApplyImport } from './routes/creator/apply'
import { Route as AuthenticatedUserImport } from './routes/_authenticated/_user'
import { Route as AuthenticatedOrganizationImport } from './routes/_authenticated/_organization'
import { Route as AuthenticatedOnboardingImport } from './routes/_authenticated/_onboarding'
import { Route as AuthenticatedExploreImport } from './routes/_authenticated/_explore'
import { Route as AuthenticatedEulaImport } from './routes/_authenticated/_eula'
import { Route as AuthenticatedDirectoryImport } from './routes/_authenticated/_directory'
import { Route as AuthenticatedCreatorImport } from './routes/_authenticated/_creator'
import { Route as TryScreenerOrganizationSlugIndexImport } from './routes/try-screener/$organizationSlug/index'
import { Route as CreatorApplyIndexImport } from './routes/creator/apply/index'
import { Route as AuthenticatedSettingsIndexImport } from './routes/_authenticated/settings/index'
import { Route as TryScreenerResultSplatImport } from './routes/try-screener/result/$'
import { Route as PeerSupportWeeklyReportTokenImport } from './routes/peer-support.weekly-report_.$token'
import { Route as AuthenticatedScreenerScreenerIdImport } from './routes/_authenticated/screener/$screenerId'
import { Route as AuthenticatedPeerSupportWeeklyReportImport } from './routes/_authenticated/peer-support.weekly-report'
import { Route as AuthenticatedAssessmentAssessmentIdImport } from './routes/_authenticated/assessment/$assessmentId'
import { Route as TryScreenerOrganizationSlugScreenerIndexImport } from './routes/try-screener/$organizationSlug/screener/index'
import { Route as CreatorApplyPreviewIndexImport } from './routes/creator/apply/preview/index'
import { Route as CreatorApplyFormIndexImport } from './routes/creator/apply/form/index'
import { Route as CreatorApplyContentPolicyIndexImport } from './routes/creator/apply/content-policy/index'
import { Route as CreatorApplyApplicationIndexImport } from './routes/creator/apply/application/index'
import { Route as AuthenticatedPeerSupportSplatIndexImport } from './routes/_authenticated/peer-support.$/index'
import { Route as AuthenticatedExploreExploreIndexImport } from './routes/_authenticated/_explore/explore.index'
import { Route as ContentCreatorApplicationPublicTokenImport } from './routes/content-creator/application/public/$token'
import { Route as AuthenticatedUserUserGrowthZoneImport } from './routes/_authenticated/_user/user.growth-zone'
import { Route as AuthenticatedUserUserDashboardImport } from './routes/_authenticated/_user/user.dashboard'
import { Route as AuthenticatedUserUserCuratedContentImport } from './routes/_authenticated/_user/user.curated-content'
import { Route as AuthenticatedOrganizationOrganizationRosterImport } from './routes/_authenticated/_organization/organization.roster'
import { Route as AuthenticatedOrganizationOrganizationDashboardImport } from './routes/_authenticated/_organization/organization.dashboard'
import { Route as AuthenticatedOnboardingOnboardingWholenessScreenerImport } from './routes/_authenticated/_onboarding/onboarding.wholeness-screener'
import { Route as AuthenticatedOnboardingOnboardingUserImport } from './routes/_authenticated/_onboarding/onboarding.user'
import { Route as AuthenticatedOnboardingOnboardingOrganizationImport } from './routes/_authenticated/_onboarding/onboarding.organization'
import { Route as AuthenticatedExploreLoopContentIdImport } from './routes/_authenticated/_explore/loop.$contentId'
import { Route as AuthenticatedExploreContentSlugImport } from './routes/_authenticated/_explore/content.$slug'
import { Route as AuthenticatedExploreArticleContentIdImport } from './routes/_authenticated/_explore/article.$contentId'
import { Route as AuthenticatedEulaEulaUpdateImport } from './routes/_authenticated/_eula/eula.update'
import { Route as AuthenticatedCreatorCreatorLibraryImport } from './routes/_authenticated/_creator/creator.library'
import { Route as AuthenticatedCreatorCreatorDashboardImport } from './routes/_authenticated/_creator/creator.dashboard'
import { Route as TryScreenerOrganizationSlugScreenerSuccessIndexImport } from './routes/try-screener/$organizationSlug/screener/success/index'
import { Route as AuthenticatedCreatorCreatorProfileIndexImport } from './routes/_authenticated/_creator/creator/profile/index'
import { Route as AuthenticatedUserProfileUserProfileImport } from './routes/_authenticated/_user/_profile/user.profile'
import { Route as AuthenticatedOrganizationOrganizationDashboardPeerSupportImport } from './routes/_authenticated/_organization/organization.dashboard_.peer-support'
import { Route as AuthenticatedExploreExploreCreatorUserIdImport } from './routes/_authenticated/_explore/explore.creator.$userId'
import { Route as AuthenticatedDirectoryProviderDirectoryProviderImport } from './routes/_authenticated/_directory/_provider/directory.provider'
import { Route as AuthenticatedDirectoryPeerSupportDirectoryPeerSupportImport } from './routes/_authenticated/_directory/_peer-support/directory.peer-support'
import { Route as AuthenticatedDirectoryMemberCareDirectoryMemberCareImport } from './routes/_authenticated/_directory/_member-care/directory.member-care'
import { Route as AuthenticatedCreatorContentCreatorContentImport } from './routes/_authenticated/_creator/_content/creator.content'
import { Route as AuthenticatedCreatorCreatorProfileEditIndexImport } from './routes/_authenticated/_creator/creator/profile/edit/index'
import { Route as AuthenticatedUserProfileUserProfileDemographicsImport } from './routes/_authenticated/_user/_profile/user.profile_.demographics'
import { Route as AuthenticatedUserProfileUserProfileContactImport } from './routes/_authenticated/_user/_profile/user.profile_.contact'
import { Route as AuthenticatedDirectoryProviderDirectoryProviderProviderIdImport } from './routes/_authenticated/_directory/_provider/directory.provider_.$providerId'
import { Route as AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdImport } from './routes/_authenticated/_directory/_peer-support/directory.peer-support_.$peerSupportId'
import { Route as AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdImport } from './routes/_authenticated/_directory/_member-care/directory.member-care_.$memberCareId'
import { Route as AuthenticatedCreatorContentCreatorContentCreateImport } from './routes/_authenticated/_creator/_content/creator.content.create'
import { Route as AuthenticatedCreatorContentCreatorContentContentIdImport } from './routes/_authenticated/_creator/_content/creator.content.$contentId'

// Create/Update Routes

const TermsOfUseRoute = TermsOfUseImport.update({
  path: '/terms-of-use',
  getParentRoute: () => rootRoute,
} as any)

const PrivacyPolicyRoute = PrivacyPolicyImport.update({
  path: '/privacy-policy',
  getParentRoute: () => rootRoute,
} as any)

const ContactSupportRoute = ContactSupportImport.update({
  path: '/contact-support',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const VerifyEmailIndexRoute = VerifyEmailIndexImport.update({
  path: '/verify-email/',
  getParentRoute: () => rootRoute,
} as any)

const TryScreenerIndexRoute = TryScreenerIndexImport.update({
  path: '/try-screener/',
  getParentRoute: () => rootRoute,
} as any)

const SignInIndexRoute = SignInIndexImport.update({
  path: '/sign-in/',
  getParentRoute: () => rootRoute,
} as any)

const LoginIndexRoute = LoginIndexImport.update({
  path: '/login/',
  getParentRoute: () => rootRoute,
} as any)

const ForgotPasswordIndexRoute = ForgotPasswordIndexImport.update({
  path: '/forgot-password/',
  getParentRoute: () => rootRoute,
} as any)

const PasswordSetupAuthTokenRoute = PasswordSetupAuthTokenImport.update({
  path: '/password-setup/$authToken',
  getParentRoute: () => rootRoute,
} as any)

const PasswordChangeAuthTokenRoute = PasswordChangeAuthTokenImport.update({
  path: '/password-change/$authToken',
  getParentRoute: () => rootRoute,
} as any)

const CreatorApplyRoute = CreatorApplyImport.update({
  path: '/creator/apply',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedUserRoute = AuthenticatedUserImport.update({
  id: '/_user',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedOrganizationRoute = AuthenticatedOrganizationImport.update({
  id: '/_organization',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedOnboardingRoute = AuthenticatedOnboardingImport.update({
  id: '/_onboarding',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedExploreRoute = AuthenticatedExploreImport.update({
  id: '/_explore',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedEulaRoute = AuthenticatedEulaImport.update({
  id: '/_eula',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedDirectoryRoute = AuthenticatedDirectoryImport.update({
  id: '/_directory',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedCreatorRoute = AuthenticatedCreatorImport.update({
  id: '/_creator',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const TryScreenerOrganizationSlugIndexRoute =
  TryScreenerOrganizationSlugIndexImport.update({
    path: '/try-screener/$organizationSlug/',
    getParentRoute: () => rootRoute,
  } as any)

const CreatorApplyIndexRoute = CreatorApplyIndexImport.update({
  path: '/',
  getParentRoute: () => CreatorApplyRoute,
} as any)

const AuthenticatedSettingsIndexRoute = AuthenticatedSettingsIndexImport.update(
  {
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any,
)

const TryScreenerResultSplatRoute = TryScreenerResultSplatImport.update({
  path: '/try-screener/result/$',
  getParentRoute: () => rootRoute,
} as any)

const PeerSupportWeeklyReportTokenRoute =
  PeerSupportWeeklyReportTokenImport.update({
    path: '/peer-support/weekly-report/$token',
    getParentRoute: () => rootRoute,
  } as any)

const AuthenticatedScreenerScreenerIdRoute =
  AuthenticatedScreenerScreenerIdImport.update({
    path: '/screener/$screenerId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedPeerSupportWeeklyReportRoute =
  AuthenticatedPeerSupportWeeklyReportImport.update({
    path: '/peer-support/weekly-report',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedAssessmentAssessmentIdRoute =
  AuthenticatedAssessmentAssessmentIdImport.update({
    path: '/assessment/$assessmentId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const TryScreenerOrganizationSlugScreenerIndexRoute =
  TryScreenerOrganizationSlugScreenerIndexImport.update({
    path: '/try-screener/$organizationSlug/screener/',
    getParentRoute: () => rootRoute,
  } as any)

const CreatorApplyPreviewIndexRoute = CreatorApplyPreviewIndexImport.update({
  path: '/preview/',
  getParentRoute: () => CreatorApplyRoute,
} as any)

const CreatorApplyFormIndexRoute = CreatorApplyFormIndexImport.update({
  path: '/form/',
  getParentRoute: () => CreatorApplyRoute,
} as any)

const CreatorApplyContentPolicyIndexRoute =
  CreatorApplyContentPolicyIndexImport.update({
    path: '/content-policy/',
    getParentRoute: () => CreatorApplyRoute,
  } as any)

const CreatorApplyApplicationIndexRoute =
  CreatorApplyApplicationIndexImport.update({
    path: '/application/',
    getParentRoute: () => CreatorApplyRoute,
  } as any)

const AuthenticatedPeerSupportSplatIndexRoute =
  AuthenticatedPeerSupportSplatIndexImport.update({
    path: '/peer-support/$/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedExploreExploreIndexRoute =
  AuthenticatedExploreExploreIndexImport.update({
    path: '/explore/',
    getParentRoute: () => AuthenticatedExploreRoute,
  } as any)

const ContentCreatorApplicationPublicTokenRoute =
  ContentCreatorApplicationPublicTokenImport.update({
    path: '/content-creator/application/public/$token',
    getParentRoute: () => rootRoute,
  } as any)

const AuthenticatedUserUserGrowthZoneRoute =
  AuthenticatedUserUserGrowthZoneImport.update({
    path: '/user/growth-zone',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedUserUserDashboardRoute =
  AuthenticatedUserUserDashboardImport.update({
    path: '/user/dashboard',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedUserUserCuratedContentRoute =
  AuthenticatedUserUserCuratedContentImport.update({
    path: '/user/curated-content',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedOrganizationOrganizationRosterRoute =
  AuthenticatedOrganizationOrganizationRosterImport.update({
    path: '/organization/roster',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)

const AuthenticatedOrganizationOrganizationDashboardRoute =
  AuthenticatedOrganizationOrganizationDashboardImport.update({
    path: '/organization/dashboard',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)

const AuthenticatedOnboardingOnboardingWholenessScreenerRoute =
  AuthenticatedOnboardingOnboardingWholenessScreenerImport.update({
    path: '/onboarding/wholeness-screener',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)

const AuthenticatedOnboardingOnboardingUserRoute =
  AuthenticatedOnboardingOnboardingUserImport.update({
    path: '/onboarding/user',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)

const AuthenticatedOnboardingOnboardingOrganizationRoute =
  AuthenticatedOnboardingOnboardingOrganizationImport.update({
    path: '/onboarding/organization',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)

const AuthenticatedExploreLoopContentIdRoute =
  AuthenticatedExploreLoopContentIdImport.update({
    path: '/loop/$contentId',
    getParentRoute: () => AuthenticatedExploreRoute,
  } as any)

const AuthenticatedExploreContentSlugRoute =
  AuthenticatedExploreContentSlugImport.update({
    path: '/content/$slug',
    getParentRoute: () => AuthenticatedExploreRoute,
  } as any)

const AuthenticatedExploreArticleContentIdRoute =
  AuthenticatedExploreArticleContentIdImport.update({
    path: '/article/$contentId',
    getParentRoute: () => AuthenticatedExploreRoute,
  } as any)

const AuthenticatedEulaEulaUpdateRoute =
  AuthenticatedEulaEulaUpdateImport.update({
    path: '/eula/update',
    getParentRoute: () => AuthenticatedEulaRoute,
  } as any)

const AuthenticatedCreatorCreatorLibraryRoute =
  AuthenticatedCreatorCreatorLibraryImport.update({
    path: '/creator/library',
    getParentRoute: () => AuthenticatedCreatorRoute,
  } as any)

const AuthenticatedCreatorCreatorDashboardRoute =
  AuthenticatedCreatorCreatorDashboardImport.update({
    path: '/creator/dashboard',
    getParentRoute: () => AuthenticatedCreatorRoute,
  } as any)

const TryScreenerOrganizationSlugScreenerSuccessIndexRoute =
  TryScreenerOrganizationSlugScreenerSuccessIndexImport.update({
    path: '/try-screener/$organizationSlug/screener/success/',
    getParentRoute: () => rootRoute,
  } as any)

const AuthenticatedCreatorCreatorProfileIndexRoute =
  AuthenticatedCreatorCreatorProfileIndexImport.update({
    path: '/creator/profile/',
    getParentRoute: () => AuthenticatedCreatorRoute,
  } as any)

const AuthenticatedUserProfileUserProfileRoute =
  AuthenticatedUserProfileUserProfileImport.update({
    path: '/user/profile',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedOrganizationOrganizationDashboardPeerSupportRoute =
  AuthenticatedOrganizationOrganizationDashboardPeerSupportImport.update({
    path: '/organization/dashboard/peer-support',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)

const AuthenticatedExploreExploreCreatorUserIdRoute =
  AuthenticatedExploreExploreCreatorUserIdImport.update({
    path: '/explore/creator/$userId',
    getParentRoute: () => AuthenticatedExploreRoute,
  } as any)

const AuthenticatedDirectoryProviderDirectoryProviderRoute =
  AuthenticatedDirectoryProviderDirectoryProviderImport.update({
    path: '/directory/provider',
    getParentRoute: () => AuthenticatedDirectoryRoute,
  } as any)

const AuthenticatedDirectoryPeerSupportDirectoryPeerSupportRoute =
  AuthenticatedDirectoryPeerSupportDirectoryPeerSupportImport.update({
    path: '/directory/peer-support',
    getParentRoute: () => AuthenticatedDirectoryRoute,
  } as any)

const AuthenticatedDirectoryMemberCareDirectoryMemberCareRoute =
  AuthenticatedDirectoryMemberCareDirectoryMemberCareImport.update({
    path: '/directory/member-care',
    getParentRoute: () => AuthenticatedDirectoryRoute,
  } as any)

const AuthenticatedCreatorContentCreatorContentRoute =
  AuthenticatedCreatorContentCreatorContentImport.update({
    path: '/creator/content',
    getParentRoute: () => AuthenticatedCreatorRoute,
  } as any)

const AuthenticatedCreatorCreatorProfileEditIndexRoute =
  AuthenticatedCreatorCreatorProfileEditIndexImport.update({
    path: '/creator/profile/edit/',
    getParentRoute: () => AuthenticatedCreatorRoute,
  } as any)

const AuthenticatedUserProfileUserProfileDemographicsRoute =
  AuthenticatedUserProfileUserProfileDemographicsImport.update({
    path: '/user/profile/demographics',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedUserProfileUserProfileContactRoute =
  AuthenticatedUserProfileUserProfileContactImport.update({
    path: '/user/profile/contact',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedDirectoryProviderDirectoryProviderProviderIdRoute =
  AuthenticatedDirectoryProviderDirectoryProviderProviderIdImport.update({
    path: '/directory/provider/$providerId',
    getParentRoute: () => AuthenticatedDirectoryRoute,
  } as any)

const AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdRoute =
  AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdImport.update(
    {
      path: '/directory/peer-support/$peerSupportId',
      getParentRoute: () => AuthenticatedDirectoryRoute,
    } as any,
  )

const AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdRoute =
  AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdImport.update({
    path: '/directory/member-care/$memberCareId',
    getParentRoute: () => AuthenticatedDirectoryRoute,
  } as any)

const AuthenticatedCreatorContentCreatorContentCreateRoute =
  AuthenticatedCreatorContentCreatorContentCreateImport.update({
    path: '/create',
    getParentRoute: () => AuthenticatedCreatorContentCreatorContentRoute,
  } as any)

const AuthenticatedCreatorContentCreatorContentContentIdRoute =
  AuthenticatedCreatorContentCreatorContentContentIdImport.update({
    path: '/$contentId',
    getParentRoute: () => AuthenticatedCreatorContentCreatorContentRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/contact-support': {
      id: '/contact-support'
      path: '/contact-support'
      fullPath: '/contact-support'
      preLoaderRoute: typeof ContactSupportImport
      parentRoute: typeof rootRoute
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyImport
      parentRoute: typeof rootRoute
    }
    '/terms-of-use': {
      id: '/terms-of-use'
      path: '/terms-of-use'
      fullPath: '/terms-of-use'
      preLoaderRoute: typeof TermsOfUseImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/_creator': {
      id: '/_authenticated/_creator'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedCreatorImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/_directory': {
      id: '/_authenticated/_directory'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedDirectoryImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/_eula': {
      id: '/_authenticated/_eula'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedEulaImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/_explore': {
      id: '/_authenticated/_explore'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedExploreImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/_onboarding': {
      id: '/_authenticated/_onboarding'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedOnboardingImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/_organization': {
      id: '/_authenticated/_organization'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedOrganizationImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/_user': {
      id: '/_authenticated/_user'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedUserImport
      parentRoute: typeof AuthenticatedImport
    }
    '/creator/apply': {
      id: '/creator/apply'
      path: '/creator/apply'
      fullPath: '/creator/apply'
      preLoaderRoute: typeof CreatorApplyImport
      parentRoute: typeof rootRoute
    }
    '/password-change/$authToken': {
      id: '/password-change/$authToken'
      path: '/password-change/$authToken'
      fullPath: '/password-change/$authToken'
      preLoaderRoute: typeof PasswordChangeAuthTokenImport
      parentRoute: typeof rootRoute
    }
    '/password-setup/$authToken': {
      id: '/password-setup/$authToken'
      path: '/password-setup/$authToken'
      fullPath: '/password-setup/$authToken'
      preLoaderRoute: typeof PasswordSetupAuthTokenImport
      parentRoute: typeof rootRoute
    }
    '/forgot-password/': {
      id: '/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordIndexImport
      parentRoute: typeof rootRoute
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexImport
      parentRoute: typeof rootRoute
    }
    '/sign-in/': {
      id: '/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInIndexImport
      parentRoute: typeof rootRoute
    }
    '/try-screener/': {
      id: '/try-screener/'
      path: '/try-screener'
      fullPath: '/try-screener'
      preLoaderRoute: typeof TryScreenerIndexImport
      parentRoute: typeof rootRoute
    }
    '/verify-email/': {
      id: '/verify-email/'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailIndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/assessment/$assessmentId': {
      id: '/_authenticated/assessment/$assessmentId'
      path: '/assessment/$assessmentId'
      fullPath: '/assessment/$assessmentId'
      preLoaderRoute: typeof AuthenticatedAssessmentAssessmentIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/peer-support/weekly-report': {
      id: '/_authenticated/peer-support/weekly-report'
      path: '/peer-support/weekly-report'
      fullPath: '/peer-support/weekly-report'
      preLoaderRoute: typeof AuthenticatedPeerSupportWeeklyReportImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/screener/$screenerId': {
      id: '/_authenticated/screener/$screenerId'
      path: '/screener/$screenerId'
      fullPath: '/screener/$screenerId'
      preLoaderRoute: typeof AuthenticatedScreenerScreenerIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/peer-support/weekly-report/$token': {
      id: '/peer-support/weekly-report/$token'
      path: '/peer-support/weekly-report/$token'
      fullPath: '/peer-support/weekly-report/$token'
      preLoaderRoute: typeof PeerSupportWeeklyReportTokenImport
      parentRoute: typeof rootRoute
    }
    '/try-screener/result/$': {
      id: '/try-screener/result/$'
      path: '/try-screener/result/$'
      fullPath: '/try-screener/result/$'
      preLoaderRoute: typeof TryScreenerResultSplatImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/creator/apply/': {
      id: '/creator/apply/'
      path: '/'
      fullPath: '/creator/apply/'
      preLoaderRoute: typeof CreatorApplyIndexImport
      parentRoute: typeof CreatorApplyImport
    }
    '/try-screener/$organizationSlug/': {
      id: '/try-screener/$organizationSlug/'
      path: '/try-screener/$organizationSlug'
      fullPath: '/try-screener/$organizationSlug'
      preLoaderRoute: typeof TryScreenerOrganizationSlugIndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/_creator/creator/dashboard': {
      id: '/_authenticated/_creator/creator/dashboard'
      path: '/creator/dashboard'
      fullPath: '/creator/dashboard'
      preLoaderRoute: typeof AuthenticatedCreatorCreatorDashboardImport
      parentRoute: typeof AuthenticatedCreatorImport
    }
    '/_authenticated/_creator/creator/library': {
      id: '/_authenticated/_creator/creator/library'
      path: '/creator/library'
      fullPath: '/creator/library'
      preLoaderRoute: typeof AuthenticatedCreatorCreatorLibraryImport
      parentRoute: typeof AuthenticatedCreatorImport
    }
    '/_authenticated/_eula/eula/update': {
      id: '/_authenticated/_eula/eula/update'
      path: '/eula/update'
      fullPath: '/eula/update'
      preLoaderRoute: typeof AuthenticatedEulaEulaUpdateImport
      parentRoute: typeof AuthenticatedEulaImport
    }
    '/_authenticated/_explore/article/$contentId': {
      id: '/_authenticated/_explore/article/$contentId'
      path: '/article/$contentId'
      fullPath: '/article/$contentId'
      preLoaderRoute: typeof AuthenticatedExploreArticleContentIdImport
      parentRoute: typeof AuthenticatedExploreImport
    }
    '/_authenticated/_explore/content/$slug': {
      id: '/_authenticated/_explore/content/$slug'
      path: '/content/$slug'
      fullPath: '/content/$slug'
      preLoaderRoute: typeof AuthenticatedExploreContentSlugImport
      parentRoute: typeof AuthenticatedExploreImport
    }
    '/_authenticated/_explore/loop/$contentId': {
      id: '/_authenticated/_explore/loop/$contentId'
      path: '/loop/$contentId'
      fullPath: '/loop/$contentId'
      preLoaderRoute: typeof AuthenticatedExploreLoopContentIdImport
      parentRoute: typeof AuthenticatedExploreImport
    }
    '/_authenticated/_onboarding/onboarding/organization': {
      id: '/_authenticated/_onboarding/onboarding/organization'
      path: '/onboarding/organization'
      fullPath: '/onboarding/organization'
      preLoaderRoute: typeof AuthenticatedOnboardingOnboardingOrganizationImport
      parentRoute: typeof AuthenticatedOnboardingImport
    }
    '/_authenticated/_onboarding/onboarding/user': {
      id: '/_authenticated/_onboarding/onboarding/user'
      path: '/onboarding/user'
      fullPath: '/onboarding/user'
      preLoaderRoute: typeof AuthenticatedOnboardingOnboardingUserImport
      parentRoute: typeof AuthenticatedOnboardingImport
    }
    '/_authenticated/_onboarding/onboarding/wholeness-screener': {
      id: '/_authenticated/_onboarding/onboarding/wholeness-screener'
      path: '/onboarding/wholeness-screener'
      fullPath: '/onboarding/wholeness-screener'
      preLoaderRoute: typeof AuthenticatedOnboardingOnboardingWholenessScreenerImport
      parentRoute: typeof AuthenticatedOnboardingImport
    }
    '/_authenticated/_organization/organization/dashboard': {
      id: '/_authenticated/_organization/organization/dashboard'
      path: '/organization/dashboard'
      fullPath: '/organization/dashboard'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationDashboardImport
      parentRoute: typeof AuthenticatedOrganizationImport
    }
    '/_authenticated/_organization/organization/roster': {
      id: '/_authenticated/_organization/organization/roster'
      path: '/organization/roster'
      fullPath: '/organization/roster'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationRosterImport
      parentRoute: typeof AuthenticatedOrganizationImport
    }
    '/_authenticated/_user/user/curated-content': {
      id: '/_authenticated/_user/user/curated-content'
      path: '/user/curated-content'
      fullPath: '/user/curated-content'
      preLoaderRoute: typeof AuthenticatedUserUserCuratedContentImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated/_user/user/dashboard': {
      id: '/_authenticated/_user/user/dashboard'
      path: '/user/dashboard'
      fullPath: '/user/dashboard'
      preLoaderRoute: typeof AuthenticatedUserUserDashboardImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated/_user/user/growth-zone': {
      id: '/_authenticated/_user/user/growth-zone'
      path: '/user/growth-zone'
      fullPath: '/user/growth-zone'
      preLoaderRoute: typeof AuthenticatedUserUserGrowthZoneImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/content-creator/application/public/$token': {
      id: '/content-creator/application/public/$token'
      path: '/content-creator/application/public/$token'
      fullPath: '/content-creator/application/public/$token'
      preLoaderRoute: typeof ContentCreatorApplicationPublicTokenImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/_explore/explore/': {
      id: '/_authenticated/_explore/explore/'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof AuthenticatedExploreExploreIndexImport
      parentRoute: typeof AuthenticatedExploreImport
    }
    '/_authenticated/peer-support/$/': {
      id: '/_authenticated/peer-support/$/'
      path: '/peer-support/$'
      fullPath: '/peer-support/$'
      preLoaderRoute: typeof AuthenticatedPeerSupportSplatIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/creator/apply/application/': {
      id: '/creator/apply/application/'
      path: '/application'
      fullPath: '/creator/apply/application'
      preLoaderRoute: typeof CreatorApplyApplicationIndexImport
      parentRoute: typeof CreatorApplyImport
    }
    '/creator/apply/content-policy/': {
      id: '/creator/apply/content-policy/'
      path: '/content-policy'
      fullPath: '/creator/apply/content-policy'
      preLoaderRoute: typeof CreatorApplyContentPolicyIndexImport
      parentRoute: typeof CreatorApplyImport
    }
    '/creator/apply/form/': {
      id: '/creator/apply/form/'
      path: '/form'
      fullPath: '/creator/apply/form'
      preLoaderRoute: typeof CreatorApplyFormIndexImport
      parentRoute: typeof CreatorApplyImport
    }
    '/creator/apply/preview/': {
      id: '/creator/apply/preview/'
      path: '/preview'
      fullPath: '/creator/apply/preview'
      preLoaderRoute: typeof CreatorApplyPreviewIndexImport
      parentRoute: typeof CreatorApplyImport
    }
    '/try-screener/$organizationSlug/screener/': {
      id: '/try-screener/$organizationSlug/screener/'
      path: '/try-screener/$organizationSlug/screener'
      fullPath: '/try-screener/$organizationSlug/screener'
      preLoaderRoute: typeof TryScreenerOrganizationSlugScreenerIndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/_creator/_content/creator/content': {
      id: '/_authenticated/_creator/_content/creator/content'
      path: '/creator/content'
      fullPath: '/creator/content'
      preLoaderRoute: typeof AuthenticatedCreatorContentCreatorContentImport
      parentRoute: typeof AuthenticatedCreatorImport
    }
    '/_authenticated/_directory/_member-care/directory/member-care': {
      id: '/_authenticated/_directory/_member-care/directory/member-care'
      path: '/directory/member-care'
      fullPath: '/directory/member-care'
      preLoaderRoute: typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareImport
      parentRoute: typeof AuthenticatedDirectoryImport
    }
    '/_authenticated/_directory/_peer-support/directory/peer-support': {
      id: '/_authenticated/_directory/_peer-support/directory/peer-support'
      path: '/directory/peer-support'
      fullPath: '/directory/peer-support'
      preLoaderRoute: typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportImport
      parentRoute: typeof AuthenticatedDirectoryImport
    }
    '/_authenticated/_directory/_provider/directory/provider': {
      id: '/_authenticated/_directory/_provider/directory/provider'
      path: '/directory/provider'
      fullPath: '/directory/provider'
      preLoaderRoute: typeof AuthenticatedDirectoryProviderDirectoryProviderImport
      parentRoute: typeof AuthenticatedDirectoryImport
    }
    '/_authenticated/_explore/explore/creator/$userId': {
      id: '/_authenticated/_explore/explore/creator/$userId'
      path: '/explore/creator/$userId'
      fullPath: '/explore/creator/$userId'
      preLoaderRoute: typeof AuthenticatedExploreExploreCreatorUserIdImport
      parentRoute: typeof AuthenticatedExploreImport
    }
    '/_authenticated/_organization/organization/dashboard/peer-support': {
      id: '/_authenticated/_organization/organization/dashboard/peer-support'
      path: '/organization/dashboard/peer-support'
      fullPath: '/organization/dashboard/peer-support'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationDashboardPeerSupportImport
      parentRoute: typeof AuthenticatedOrganizationImport
    }
    '/_authenticated/_user/_profile/user/profile': {
      id: '/_authenticated/_user/_profile/user/profile'
      path: '/user/profile'
      fullPath: '/user/profile'
      preLoaderRoute: typeof AuthenticatedUserProfileUserProfileImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated/_creator/creator/profile/': {
      id: '/_authenticated/_creator/creator/profile/'
      path: '/creator/profile'
      fullPath: '/creator/profile'
      preLoaderRoute: typeof AuthenticatedCreatorCreatorProfileIndexImport
      parentRoute: typeof AuthenticatedCreatorImport
    }
    '/try-screener/$organizationSlug/screener/success/': {
      id: '/try-screener/$organizationSlug/screener/success/'
      path: '/try-screener/$organizationSlug/screener/success'
      fullPath: '/try-screener/$organizationSlug/screener/success'
      preLoaderRoute: typeof TryScreenerOrganizationSlugScreenerSuccessIndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/_creator/_content/creator/content/$contentId': {
      id: '/_authenticated/_creator/_content/creator/content/$contentId'
      path: '/$contentId'
      fullPath: '/creator/content/$contentId'
      preLoaderRoute: typeof AuthenticatedCreatorContentCreatorContentContentIdImport
      parentRoute: typeof AuthenticatedCreatorContentCreatorContentImport
    }
    '/_authenticated/_creator/_content/creator/content/create': {
      id: '/_authenticated/_creator/_content/creator/content/create'
      path: '/create'
      fullPath: '/creator/content/create'
      preLoaderRoute: typeof AuthenticatedCreatorContentCreatorContentCreateImport
      parentRoute: typeof AuthenticatedCreatorContentCreatorContentImport
    }
    '/_authenticated/_directory/_member-care/directory/member-care/$memberCareId': {
      id: '/_authenticated/_directory/_member-care/directory/member-care/$memberCareId'
      path: '/directory/member-care/$memberCareId'
      fullPath: '/directory/member-care/$memberCareId'
      preLoaderRoute: typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdImport
      parentRoute: typeof AuthenticatedDirectoryImport
    }
    '/_authenticated/_directory/_peer-support/directory/peer-support/$peerSupportId': {
      id: '/_authenticated/_directory/_peer-support/directory/peer-support/$peerSupportId'
      path: '/directory/peer-support/$peerSupportId'
      fullPath: '/directory/peer-support/$peerSupportId'
      preLoaderRoute: typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdImport
      parentRoute: typeof AuthenticatedDirectoryImport
    }
    '/_authenticated/_directory/_provider/directory/provider/$providerId': {
      id: '/_authenticated/_directory/_provider/directory/provider/$providerId'
      path: '/directory/provider/$providerId'
      fullPath: '/directory/provider/$providerId'
      preLoaderRoute: typeof AuthenticatedDirectoryProviderDirectoryProviderProviderIdImport
      parentRoute: typeof AuthenticatedDirectoryImport
    }
    '/_authenticated/_user/_profile/user/profile/contact': {
      id: '/_authenticated/_user/_profile/user/profile/contact'
      path: '/user/profile/contact'
      fullPath: '/user/profile/contact'
      preLoaderRoute: typeof AuthenticatedUserProfileUserProfileContactImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated/_user/_profile/user/profile/demographics': {
      id: '/_authenticated/_user/_profile/user/profile/demographics'
      path: '/user/profile/demographics'
      fullPath: '/user/profile/demographics'
      preLoaderRoute: typeof AuthenticatedUserProfileUserProfileDemographicsImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated/_creator/creator/profile/edit/': {
      id: '/_authenticated/_creator/creator/profile/edit/'
      path: '/creator/profile/edit'
      fullPath: '/creator/profile/edit'
      preLoaderRoute: typeof AuthenticatedCreatorCreatorProfileEditIndexImport
      parentRoute: typeof AuthenticatedCreatorImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedCreatorContentCreatorContentRouteChildren {
  AuthenticatedCreatorContentCreatorContentContentIdRoute: typeof AuthenticatedCreatorContentCreatorContentContentIdRoute
  AuthenticatedCreatorContentCreatorContentCreateRoute: typeof AuthenticatedCreatorContentCreatorContentCreateRoute
}

const AuthenticatedCreatorContentCreatorContentRouteChildren: AuthenticatedCreatorContentCreatorContentRouteChildren =
  {
    AuthenticatedCreatorContentCreatorContentContentIdRoute:
      AuthenticatedCreatorContentCreatorContentContentIdRoute,
    AuthenticatedCreatorContentCreatorContentCreateRoute:
      AuthenticatedCreatorContentCreatorContentCreateRoute,
  }

const AuthenticatedCreatorContentCreatorContentRouteWithChildren =
  AuthenticatedCreatorContentCreatorContentRoute._addFileChildren(
    AuthenticatedCreatorContentCreatorContentRouteChildren,
  )

interface AuthenticatedCreatorRouteChildren {
  AuthenticatedCreatorCreatorDashboardRoute: typeof AuthenticatedCreatorCreatorDashboardRoute
  AuthenticatedCreatorCreatorLibraryRoute: typeof AuthenticatedCreatorCreatorLibraryRoute
  AuthenticatedCreatorContentCreatorContentRoute: typeof AuthenticatedCreatorContentCreatorContentRouteWithChildren
  AuthenticatedCreatorCreatorProfileIndexRoute: typeof AuthenticatedCreatorCreatorProfileIndexRoute
  AuthenticatedCreatorCreatorProfileEditIndexRoute: typeof AuthenticatedCreatorCreatorProfileEditIndexRoute
}

const AuthenticatedCreatorRouteChildren: AuthenticatedCreatorRouteChildren = {
  AuthenticatedCreatorCreatorDashboardRoute:
    AuthenticatedCreatorCreatorDashboardRoute,
  AuthenticatedCreatorCreatorLibraryRoute:
    AuthenticatedCreatorCreatorLibraryRoute,
  AuthenticatedCreatorContentCreatorContentRoute:
    AuthenticatedCreatorContentCreatorContentRouteWithChildren,
  AuthenticatedCreatorCreatorProfileIndexRoute:
    AuthenticatedCreatorCreatorProfileIndexRoute,
  AuthenticatedCreatorCreatorProfileEditIndexRoute:
    AuthenticatedCreatorCreatorProfileEditIndexRoute,
}

const AuthenticatedCreatorRouteWithChildren =
  AuthenticatedCreatorRoute._addFileChildren(AuthenticatedCreatorRouteChildren)

interface AuthenticatedDirectoryRouteChildren {
  AuthenticatedDirectoryMemberCareDirectoryMemberCareRoute: typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareRoute
  AuthenticatedDirectoryPeerSupportDirectoryPeerSupportRoute: typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportRoute
  AuthenticatedDirectoryProviderDirectoryProviderRoute: typeof AuthenticatedDirectoryProviderDirectoryProviderRoute
  AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdRoute: typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdRoute
  AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdRoute: typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdRoute
  AuthenticatedDirectoryProviderDirectoryProviderProviderIdRoute: typeof AuthenticatedDirectoryProviderDirectoryProviderProviderIdRoute
}

const AuthenticatedDirectoryRouteChildren: AuthenticatedDirectoryRouteChildren =
  {
    AuthenticatedDirectoryMemberCareDirectoryMemberCareRoute:
      AuthenticatedDirectoryMemberCareDirectoryMemberCareRoute,
    AuthenticatedDirectoryPeerSupportDirectoryPeerSupportRoute:
      AuthenticatedDirectoryPeerSupportDirectoryPeerSupportRoute,
    AuthenticatedDirectoryProviderDirectoryProviderRoute:
      AuthenticatedDirectoryProviderDirectoryProviderRoute,
    AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdRoute:
      AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdRoute,
    AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdRoute:
      AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdRoute,
    AuthenticatedDirectoryProviderDirectoryProviderProviderIdRoute:
      AuthenticatedDirectoryProviderDirectoryProviderProviderIdRoute,
  }

const AuthenticatedDirectoryRouteWithChildren =
  AuthenticatedDirectoryRoute._addFileChildren(
    AuthenticatedDirectoryRouteChildren,
  )

interface AuthenticatedEulaRouteChildren {
  AuthenticatedEulaEulaUpdateRoute: typeof AuthenticatedEulaEulaUpdateRoute
}

const AuthenticatedEulaRouteChildren: AuthenticatedEulaRouteChildren = {
  AuthenticatedEulaEulaUpdateRoute: AuthenticatedEulaEulaUpdateRoute,
}

const AuthenticatedEulaRouteWithChildren =
  AuthenticatedEulaRoute._addFileChildren(AuthenticatedEulaRouteChildren)

interface AuthenticatedExploreRouteChildren {
  AuthenticatedExploreArticleContentIdRoute: typeof AuthenticatedExploreArticleContentIdRoute
  AuthenticatedExploreContentSlugRoute: typeof AuthenticatedExploreContentSlugRoute
  AuthenticatedExploreLoopContentIdRoute: typeof AuthenticatedExploreLoopContentIdRoute
  AuthenticatedExploreExploreIndexRoute: typeof AuthenticatedExploreExploreIndexRoute
  AuthenticatedExploreExploreCreatorUserIdRoute: typeof AuthenticatedExploreExploreCreatorUserIdRoute
}

const AuthenticatedExploreRouteChildren: AuthenticatedExploreRouteChildren = {
  AuthenticatedExploreArticleContentIdRoute:
    AuthenticatedExploreArticleContentIdRoute,
  AuthenticatedExploreContentSlugRoute: AuthenticatedExploreContentSlugRoute,
  AuthenticatedExploreLoopContentIdRoute:
    AuthenticatedExploreLoopContentIdRoute,
  AuthenticatedExploreExploreIndexRoute: AuthenticatedExploreExploreIndexRoute,
  AuthenticatedExploreExploreCreatorUserIdRoute:
    AuthenticatedExploreExploreCreatorUserIdRoute,
}

const AuthenticatedExploreRouteWithChildren =
  AuthenticatedExploreRoute._addFileChildren(AuthenticatedExploreRouteChildren)

interface AuthenticatedOnboardingRouteChildren {
  AuthenticatedOnboardingOnboardingOrganizationRoute: typeof AuthenticatedOnboardingOnboardingOrganizationRoute
  AuthenticatedOnboardingOnboardingUserRoute: typeof AuthenticatedOnboardingOnboardingUserRoute
  AuthenticatedOnboardingOnboardingWholenessScreenerRoute: typeof AuthenticatedOnboardingOnboardingWholenessScreenerRoute
}

const AuthenticatedOnboardingRouteChildren: AuthenticatedOnboardingRouteChildren =
  {
    AuthenticatedOnboardingOnboardingOrganizationRoute:
      AuthenticatedOnboardingOnboardingOrganizationRoute,
    AuthenticatedOnboardingOnboardingUserRoute:
      AuthenticatedOnboardingOnboardingUserRoute,
    AuthenticatedOnboardingOnboardingWholenessScreenerRoute:
      AuthenticatedOnboardingOnboardingWholenessScreenerRoute,
  }

const AuthenticatedOnboardingRouteWithChildren =
  AuthenticatedOnboardingRoute._addFileChildren(
    AuthenticatedOnboardingRouteChildren,
  )

interface AuthenticatedOrganizationRouteChildren {
  AuthenticatedOrganizationOrganizationDashboardRoute: typeof AuthenticatedOrganizationOrganizationDashboardRoute
  AuthenticatedOrganizationOrganizationRosterRoute: typeof AuthenticatedOrganizationOrganizationRosterRoute
  AuthenticatedOrganizationOrganizationDashboardPeerSupportRoute: typeof AuthenticatedOrganizationOrganizationDashboardPeerSupportRoute
}

const AuthenticatedOrganizationRouteChildren: AuthenticatedOrganizationRouteChildren =
  {
    AuthenticatedOrganizationOrganizationDashboardRoute:
      AuthenticatedOrganizationOrganizationDashboardRoute,
    AuthenticatedOrganizationOrganizationRosterRoute:
      AuthenticatedOrganizationOrganizationRosterRoute,
    AuthenticatedOrganizationOrganizationDashboardPeerSupportRoute:
      AuthenticatedOrganizationOrganizationDashboardPeerSupportRoute,
  }

const AuthenticatedOrganizationRouteWithChildren =
  AuthenticatedOrganizationRoute._addFileChildren(
    AuthenticatedOrganizationRouteChildren,
  )

interface AuthenticatedUserRouteChildren {
  AuthenticatedUserUserCuratedContentRoute: typeof AuthenticatedUserUserCuratedContentRoute
  AuthenticatedUserUserDashboardRoute: typeof AuthenticatedUserUserDashboardRoute
  AuthenticatedUserUserGrowthZoneRoute: typeof AuthenticatedUserUserGrowthZoneRoute
  AuthenticatedUserProfileUserProfileRoute: typeof AuthenticatedUserProfileUserProfileRoute
  AuthenticatedUserProfileUserProfileContactRoute: typeof AuthenticatedUserProfileUserProfileContactRoute
  AuthenticatedUserProfileUserProfileDemographicsRoute: typeof AuthenticatedUserProfileUserProfileDemographicsRoute
}

const AuthenticatedUserRouteChildren: AuthenticatedUserRouteChildren = {
  AuthenticatedUserUserCuratedContentRoute:
    AuthenticatedUserUserCuratedContentRoute,
  AuthenticatedUserUserDashboardRoute: AuthenticatedUserUserDashboardRoute,
  AuthenticatedUserUserGrowthZoneRoute: AuthenticatedUserUserGrowthZoneRoute,
  AuthenticatedUserProfileUserProfileRoute:
    AuthenticatedUserProfileUserProfileRoute,
  AuthenticatedUserProfileUserProfileContactRoute:
    AuthenticatedUserProfileUserProfileContactRoute,
  AuthenticatedUserProfileUserProfileDemographicsRoute:
    AuthenticatedUserProfileUserProfileDemographicsRoute,
}

const AuthenticatedUserRouteWithChildren =
  AuthenticatedUserRoute._addFileChildren(AuthenticatedUserRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedCreatorRoute: typeof AuthenticatedCreatorRouteWithChildren
  AuthenticatedDirectoryRoute: typeof AuthenticatedDirectoryRouteWithChildren
  AuthenticatedEulaRoute: typeof AuthenticatedEulaRouteWithChildren
  AuthenticatedExploreRoute: typeof AuthenticatedExploreRouteWithChildren
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRouteWithChildren
  AuthenticatedOrganizationRoute: typeof AuthenticatedOrganizationRouteWithChildren
  AuthenticatedUserRoute: typeof AuthenticatedUserRouteWithChildren
  AuthenticatedAssessmentAssessmentIdRoute: typeof AuthenticatedAssessmentAssessmentIdRoute
  AuthenticatedPeerSupportWeeklyReportRoute: typeof AuthenticatedPeerSupportWeeklyReportRoute
  AuthenticatedScreenerScreenerIdRoute: typeof AuthenticatedScreenerScreenerIdRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedPeerSupportSplatIndexRoute: typeof AuthenticatedPeerSupportSplatIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCreatorRoute: AuthenticatedCreatorRouteWithChildren,
  AuthenticatedDirectoryRoute: AuthenticatedDirectoryRouteWithChildren,
  AuthenticatedEulaRoute: AuthenticatedEulaRouteWithChildren,
  AuthenticatedExploreRoute: AuthenticatedExploreRouteWithChildren,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRouteWithChildren,
  AuthenticatedOrganizationRoute: AuthenticatedOrganizationRouteWithChildren,
  AuthenticatedUserRoute: AuthenticatedUserRouteWithChildren,
  AuthenticatedAssessmentAssessmentIdRoute:
    AuthenticatedAssessmentAssessmentIdRoute,
  AuthenticatedPeerSupportWeeklyReportRoute:
    AuthenticatedPeerSupportWeeklyReportRoute,
  AuthenticatedScreenerScreenerIdRoute: AuthenticatedScreenerScreenerIdRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedPeerSupportSplatIndexRoute:
    AuthenticatedPeerSupportSplatIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface CreatorApplyRouteChildren {
  CreatorApplyIndexRoute: typeof CreatorApplyIndexRoute
  CreatorApplyApplicationIndexRoute: typeof CreatorApplyApplicationIndexRoute
  CreatorApplyContentPolicyIndexRoute: typeof CreatorApplyContentPolicyIndexRoute
  CreatorApplyFormIndexRoute: typeof CreatorApplyFormIndexRoute
  CreatorApplyPreviewIndexRoute: typeof CreatorApplyPreviewIndexRoute
}

const CreatorApplyRouteChildren: CreatorApplyRouteChildren = {
  CreatorApplyIndexRoute: CreatorApplyIndexRoute,
  CreatorApplyApplicationIndexRoute: CreatorApplyApplicationIndexRoute,
  CreatorApplyContentPolicyIndexRoute: CreatorApplyContentPolicyIndexRoute,
  CreatorApplyFormIndexRoute: CreatorApplyFormIndexRoute,
  CreatorApplyPreviewIndexRoute: CreatorApplyPreviewIndexRoute,
}

const CreatorApplyRouteWithChildren = CreatorApplyRoute._addFileChildren(
  CreatorApplyRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AuthenticatedUserRouteWithChildren
  '/contact-support': typeof ContactSupportRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-use': typeof TermsOfUseRoute
  '/creator/apply': typeof CreatorApplyRouteWithChildren
  '/password-change/$authToken': typeof PasswordChangeAuthTokenRoute
  '/password-setup/$authToken': typeof PasswordSetupAuthTokenRoute
  '/forgot-password': typeof ForgotPasswordIndexRoute
  '/login': typeof LoginIndexRoute
  '/sign-in': typeof SignInIndexRoute
  '/try-screener': typeof TryScreenerIndexRoute
  '/verify-email': typeof VerifyEmailIndexRoute
  '/assessment/$assessmentId': typeof AuthenticatedAssessmentAssessmentIdRoute
  '/peer-support/weekly-report': typeof AuthenticatedPeerSupportWeeklyReportRoute
  '/screener/$screenerId': typeof AuthenticatedScreenerScreenerIdRoute
  '/peer-support/weekly-report/$token': typeof PeerSupportWeeklyReportTokenRoute
  '/try-screener/result/$': typeof TryScreenerResultSplatRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/creator/apply/': typeof CreatorApplyIndexRoute
  '/try-screener/$organizationSlug': typeof TryScreenerOrganizationSlugIndexRoute
  '/creator/dashboard': typeof AuthenticatedCreatorCreatorDashboardRoute
  '/creator/library': typeof AuthenticatedCreatorCreatorLibraryRoute
  '/eula/update': typeof AuthenticatedEulaEulaUpdateRoute
  '/article/$contentId': typeof AuthenticatedExploreArticleContentIdRoute
  '/content/$slug': typeof AuthenticatedExploreContentSlugRoute
  '/loop/$contentId': typeof AuthenticatedExploreLoopContentIdRoute
  '/onboarding/organization': typeof AuthenticatedOnboardingOnboardingOrganizationRoute
  '/onboarding/user': typeof AuthenticatedOnboardingOnboardingUserRoute
  '/onboarding/wholeness-screener': typeof AuthenticatedOnboardingOnboardingWholenessScreenerRoute
  '/organization/dashboard': typeof AuthenticatedOrganizationOrganizationDashboardRoute
  '/organization/roster': typeof AuthenticatedOrganizationOrganizationRosterRoute
  '/user/curated-content': typeof AuthenticatedUserUserCuratedContentRoute
  '/user/dashboard': typeof AuthenticatedUserUserDashboardRoute
  '/user/growth-zone': typeof AuthenticatedUserUserGrowthZoneRoute
  '/content-creator/application/public/$token': typeof ContentCreatorApplicationPublicTokenRoute
  '/explore': typeof AuthenticatedExploreExploreIndexRoute
  '/peer-support/$': typeof AuthenticatedPeerSupportSplatIndexRoute
  '/creator/apply/application': typeof CreatorApplyApplicationIndexRoute
  '/creator/apply/content-policy': typeof CreatorApplyContentPolicyIndexRoute
  '/creator/apply/form': typeof CreatorApplyFormIndexRoute
  '/creator/apply/preview': typeof CreatorApplyPreviewIndexRoute
  '/try-screener/$organizationSlug/screener': typeof TryScreenerOrganizationSlugScreenerIndexRoute
  '/creator/content': typeof AuthenticatedCreatorContentCreatorContentRouteWithChildren
  '/directory/member-care': typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareRoute
  '/directory/peer-support': typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportRoute
  '/directory/provider': typeof AuthenticatedDirectoryProviderDirectoryProviderRoute
  '/explore/creator/$userId': typeof AuthenticatedExploreExploreCreatorUserIdRoute
  '/organization/dashboard/peer-support': typeof AuthenticatedOrganizationOrganizationDashboardPeerSupportRoute
  '/user/profile': typeof AuthenticatedUserProfileUserProfileRoute
  '/creator/profile': typeof AuthenticatedCreatorCreatorProfileIndexRoute
  '/try-screener/$organizationSlug/screener/success': typeof TryScreenerOrganizationSlugScreenerSuccessIndexRoute
  '/creator/content/$contentId': typeof AuthenticatedCreatorContentCreatorContentContentIdRoute
  '/creator/content/create': typeof AuthenticatedCreatorContentCreatorContentCreateRoute
  '/directory/member-care/$memberCareId': typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdRoute
  '/directory/peer-support/$peerSupportId': typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdRoute
  '/directory/provider/$providerId': typeof AuthenticatedDirectoryProviderDirectoryProviderProviderIdRoute
  '/user/profile/contact': typeof AuthenticatedUserProfileUserProfileContactRoute
  '/user/profile/demographics': typeof AuthenticatedUserProfileUserProfileDemographicsRoute
  '/creator/profile/edit': typeof AuthenticatedCreatorCreatorProfileEditIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AuthenticatedUserRouteWithChildren
  '/contact-support': typeof ContactSupportRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-use': typeof TermsOfUseRoute
  '/password-change/$authToken': typeof PasswordChangeAuthTokenRoute
  '/password-setup/$authToken': typeof PasswordSetupAuthTokenRoute
  '/forgot-password': typeof ForgotPasswordIndexRoute
  '/login': typeof LoginIndexRoute
  '/sign-in': typeof SignInIndexRoute
  '/try-screener': typeof TryScreenerIndexRoute
  '/verify-email': typeof VerifyEmailIndexRoute
  '/assessment/$assessmentId': typeof AuthenticatedAssessmentAssessmentIdRoute
  '/peer-support/weekly-report': typeof AuthenticatedPeerSupportWeeklyReportRoute
  '/screener/$screenerId': typeof AuthenticatedScreenerScreenerIdRoute
  '/peer-support/weekly-report/$token': typeof PeerSupportWeeklyReportTokenRoute
  '/try-screener/result/$': typeof TryScreenerResultSplatRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/creator/apply': typeof CreatorApplyIndexRoute
  '/try-screener/$organizationSlug': typeof TryScreenerOrganizationSlugIndexRoute
  '/creator/dashboard': typeof AuthenticatedCreatorCreatorDashboardRoute
  '/creator/library': typeof AuthenticatedCreatorCreatorLibraryRoute
  '/eula/update': typeof AuthenticatedEulaEulaUpdateRoute
  '/article/$contentId': typeof AuthenticatedExploreArticleContentIdRoute
  '/content/$slug': typeof AuthenticatedExploreContentSlugRoute
  '/loop/$contentId': typeof AuthenticatedExploreLoopContentIdRoute
  '/onboarding/organization': typeof AuthenticatedOnboardingOnboardingOrganizationRoute
  '/onboarding/user': typeof AuthenticatedOnboardingOnboardingUserRoute
  '/onboarding/wholeness-screener': typeof AuthenticatedOnboardingOnboardingWholenessScreenerRoute
  '/organization/dashboard': typeof AuthenticatedOrganizationOrganizationDashboardRoute
  '/organization/roster': typeof AuthenticatedOrganizationOrganizationRosterRoute
  '/user/curated-content': typeof AuthenticatedUserUserCuratedContentRoute
  '/user/dashboard': typeof AuthenticatedUserUserDashboardRoute
  '/user/growth-zone': typeof AuthenticatedUserUserGrowthZoneRoute
  '/content-creator/application/public/$token': typeof ContentCreatorApplicationPublicTokenRoute
  '/explore': typeof AuthenticatedExploreExploreIndexRoute
  '/peer-support/$': typeof AuthenticatedPeerSupportSplatIndexRoute
  '/creator/apply/application': typeof CreatorApplyApplicationIndexRoute
  '/creator/apply/content-policy': typeof CreatorApplyContentPolicyIndexRoute
  '/creator/apply/form': typeof CreatorApplyFormIndexRoute
  '/creator/apply/preview': typeof CreatorApplyPreviewIndexRoute
  '/try-screener/$organizationSlug/screener': typeof TryScreenerOrganizationSlugScreenerIndexRoute
  '/creator/content': typeof AuthenticatedCreatorContentCreatorContentRouteWithChildren
  '/directory/member-care': typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareRoute
  '/directory/peer-support': typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportRoute
  '/directory/provider': typeof AuthenticatedDirectoryProviderDirectoryProviderRoute
  '/explore/creator/$userId': typeof AuthenticatedExploreExploreCreatorUserIdRoute
  '/organization/dashboard/peer-support': typeof AuthenticatedOrganizationOrganizationDashboardPeerSupportRoute
  '/user/profile': typeof AuthenticatedUserProfileUserProfileRoute
  '/creator/profile': typeof AuthenticatedCreatorCreatorProfileIndexRoute
  '/try-screener/$organizationSlug/screener/success': typeof TryScreenerOrganizationSlugScreenerSuccessIndexRoute
  '/creator/content/$contentId': typeof AuthenticatedCreatorContentCreatorContentContentIdRoute
  '/creator/content/create': typeof AuthenticatedCreatorContentCreatorContentCreateRoute
  '/directory/member-care/$memberCareId': typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdRoute
  '/directory/peer-support/$peerSupportId': typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdRoute
  '/directory/provider/$providerId': typeof AuthenticatedDirectoryProviderDirectoryProviderProviderIdRoute
  '/user/profile/contact': typeof AuthenticatedUserProfileUserProfileContactRoute
  '/user/profile/demographics': typeof AuthenticatedUserProfileUserProfileDemographicsRoute
  '/creator/profile/edit': typeof AuthenticatedCreatorCreatorProfileEditIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/contact-support': typeof ContactSupportRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-use': typeof TermsOfUseRoute
  '/_authenticated/_creator': typeof AuthenticatedCreatorRouteWithChildren
  '/_authenticated/_directory': typeof AuthenticatedDirectoryRouteWithChildren
  '/_authenticated/_eula': typeof AuthenticatedEulaRouteWithChildren
  '/_authenticated/_explore': typeof AuthenticatedExploreRouteWithChildren
  '/_authenticated/_onboarding': typeof AuthenticatedOnboardingRouteWithChildren
  '/_authenticated/_organization': typeof AuthenticatedOrganizationRouteWithChildren
  '/_authenticated/_user': typeof AuthenticatedUserRouteWithChildren
  '/creator/apply': typeof CreatorApplyRouteWithChildren
  '/password-change/$authToken': typeof PasswordChangeAuthTokenRoute
  '/password-setup/$authToken': typeof PasswordSetupAuthTokenRoute
  '/forgot-password/': typeof ForgotPasswordIndexRoute
  '/login/': typeof LoginIndexRoute
  '/sign-in/': typeof SignInIndexRoute
  '/try-screener/': typeof TryScreenerIndexRoute
  '/verify-email/': typeof VerifyEmailIndexRoute
  '/_authenticated/assessment/$assessmentId': typeof AuthenticatedAssessmentAssessmentIdRoute
  '/_authenticated/peer-support/weekly-report': typeof AuthenticatedPeerSupportWeeklyReportRoute
  '/_authenticated/screener/$screenerId': typeof AuthenticatedScreenerScreenerIdRoute
  '/peer-support/weekly-report/$token': typeof PeerSupportWeeklyReportTokenRoute
  '/try-screener/result/$': typeof TryScreenerResultSplatRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/creator/apply/': typeof CreatorApplyIndexRoute
  '/try-screener/$organizationSlug/': typeof TryScreenerOrganizationSlugIndexRoute
  '/_authenticated/_creator/creator/dashboard': typeof AuthenticatedCreatorCreatorDashboardRoute
  '/_authenticated/_creator/creator/library': typeof AuthenticatedCreatorCreatorLibraryRoute
  '/_authenticated/_eula/eula/update': typeof AuthenticatedEulaEulaUpdateRoute
  '/_authenticated/_explore/article/$contentId': typeof AuthenticatedExploreArticleContentIdRoute
  '/_authenticated/_explore/content/$slug': typeof AuthenticatedExploreContentSlugRoute
  '/_authenticated/_explore/loop/$contentId': typeof AuthenticatedExploreLoopContentIdRoute
  '/_authenticated/_onboarding/onboarding/organization': typeof AuthenticatedOnboardingOnboardingOrganizationRoute
  '/_authenticated/_onboarding/onboarding/user': typeof AuthenticatedOnboardingOnboardingUserRoute
  '/_authenticated/_onboarding/onboarding/wholeness-screener': typeof AuthenticatedOnboardingOnboardingWholenessScreenerRoute
  '/_authenticated/_organization/organization/dashboard': typeof AuthenticatedOrganizationOrganizationDashboardRoute
  '/_authenticated/_organization/organization/roster': typeof AuthenticatedOrganizationOrganizationRosterRoute
  '/_authenticated/_user/user/curated-content': typeof AuthenticatedUserUserCuratedContentRoute
  '/_authenticated/_user/user/dashboard': typeof AuthenticatedUserUserDashboardRoute
  '/_authenticated/_user/user/growth-zone': typeof AuthenticatedUserUserGrowthZoneRoute
  '/content-creator/application/public/$token': typeof ContentCreatorApplicationPublicTokenRoute
  '/_authenticated/_explore/explore/': typeof AuthenticatedExploreExploreIndexRoute
  '/_authenticated/peer-support/$/': typeof AuthenticatedPeerSupportSplatIndexRoute
  '/creator/apply/application/': typeof CreatorApplyApplicationIndexRoute
  '/creator/apply/content-policy/': typeof CreatorApplyContentPolicyIndexRoute
  '/creator/apply/form/': typeof CreatorApplyFormIndexRoute
  '/creator/apply/preview/': typeof CreatorApplyPreviewIndexRoute
  '/try-screener/$organizationSlug/screener/': typeof TryScreenerOrganizationSlugScreenerIndexRoute
  '/_authenticated/_creator/_content/creator/content': typeof AuthenticatedCreatorContentCreatorContentRouteWithChildren
  '/_authenticated/_directory/_member-care/directory/member-care': typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareRoute
  '/_authenticated/_directory/_peer-support/directory/peer-support': typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportRoute
  '/_authenticated/_directory/_provider/directory/provider': typeof AuthenticatedDirectoryProviderDirectoryProviderRoute
  '/_authenticated/_explore/explore/creator/$userId': typeof AuthenticatedExploreExploreCreatorUserIdRoute
  '/_authenticated/_organization/organization/dashboard/peer-support': typeof AuthenticatedOrganizationOrganizationDashboardPeerSupportRoute
  '/_authenticated/_user/_profile/user/profile': typeof AuthenticatedUserProfileUserProfileRoute
  '/_authenticated/_creator/creator/profile/': typeof AuthenticatedCreatorCreatorProfileIndexRoute
  '/try-screener/$organizationSlug/screener/success/': typeof TryScreenerOrganizationSlugScreenerSuccessIndexRoute
  '/_authenticated/_creator/_content/creator/content/$contentId': typeof AuthenticatedCreatorContentCreatorContentContentIdRoute
  '/_authenticated/_creator/_content/creator/content/create': typeof AuthenticatedCreatorContentCreatorContentCreateRoute
  '/_authenticated/_directory/_member-care/directory/member-care/$memberCareId': typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdRoute
  '/_authenticated/_directory/_peer-support/directory/peer-support/$peerSupportId': typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdRoute
  '/_authenticated/_directory/_provider/directory/provider/$providerId': typeof AuthenticatedDirectoryProviderDirectoryProviderProviderIdRoute
  '/_authenticated/_user/_profile/user/profile/contact': typeof AuthenticatedUserProfileUserProfileContactRoute
  '/_authenticated/_user/_profile/user/profile/demographics': typeof AuthenticatedUserProfileUserProfileDemographicsRoute
  '/_authenticated/_creator/creator/profile/edit/': typeof AuthenticatedCreatorCreatorProfileEditIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/contact-support'
    | '/privacy-policy'
    | '/terms-of-use'
    | '/creator/apply'
    | '/password-change/$authToken'
    | '/password-setup/$authToken'
    | '/forgot-password'
    | '/login'
    | '/sign-in'
    | '/try-screener'
    | '/verify-email'
    | '/assessment/$assessmentId'
    | '/peer-support/weekly-report'
    | '/screener/$screenerId'
    | '/peer-support/weekly-report/$token'
    | '/try-screener/result/$'
    | '/settings'
    | '/creator/apply/'
    | '/try-screener/$organizationSlug'
    | '/creator/dashboard'
    | '/creator/library'
    | '/eula/update'
    | '/article/$contentId'
    | '/content/$slug'
    | '/loop/$contentId'
    | '/onboarding/organization'
    | '/onboarding/user'
    | '/onboarding/wholeness-screener'
    | '/organization/dashboard'
    | '/organization/roster'
    | '/user/curated-content'
    | '/user/dashboard'
    | '/user/growth-zone'
    | '/content-creator/application/public/$token'
    | '/explore'
    | '/peer-support/$'
    | '/creator/apply/application'
    | '/creator/apply/content-policy'
    | '/creator/apply/form'
    | '/creator/apply/preview'
    | '/try-screener/$organizationSlug/screener'
    | '/creator/content'
    | '/directory/member-care'
    | '/directory/peer-support'
    | '/directory/provider'
    | '/explore/creator/$userId'
    | '/organization/dashboard/peer-support'
    | '/user/profile'
    | '/creator/profile'
    | '/try-screener/$organizationSlug/screener/success'
    | '/creator/content/$contentId'
    | '/creator/content/create'
    | '/directory/member-care/$memberCareId'
    | '/directory/peer-support/$peerSupportId'
    | '/directory/provider/$providerId'
    | '/user/profile/contact'
    | '/user/profile/demographics'
    | '/creator/profile/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/contact-support'
    | '/privacy-policy'
    | '/terms-of-use'
    | '/password-change/$authToken'
    | '/password-setup/$authToken'
    | '/forgot-password'
    | '/login'
    | '/sign-in'
    | '/try-screener'
    | '/verify-email'
    | '/assessment/$assessmentId'
    | '/peer-support/weekly-report'
    | '/screener/$screenerId'
    | '/peer-support/weekly-report/$token'
    | '/try-screener/result/$'
    | '/settings'
    | '/creator/apply'
    | '/try-screener/$organizationSlug'
    | '/creator/dashboard'
    | '/creator/library'
    | '/eula/update'
    | '/article/$contentId'
    | '/content/$slug'
    | '/loop/$contentId'
    | '/onboarding/organization'
    | '/onboarding/user'
    | '/onboarding/wholeness-screener'
    | '/organization/dashboard'
    | '/organization/roster'
    | '/user/curated-content'
    | '/user/dashboard'
    | '/user/growth-zone'
    | '/content-creator/application/public/$token'
    | '/explore'
    | '/peer-support/$'
    | '/creator/apply/application'
    | '/creator/apply/content-policy'
    | '/creator/apply/form'
    | '/creator/apply/preview'
    | '/try-screener/$organizationSlug/screener'
    | '/creator/content'
    | '/directory/member-care'
    | '/directory/peer-support'
    | '/directory/provider'
    | '/explore/creator/$userId'
    | '/organization/dashboard/peer-support'
    | '/user/profile'
    | '/creator/profile'
    | '/try-screener/$organizationSlug/screener/success'
    | '/creator/content/$contentId'
    | '/creator/content/create'
    | '/directory/member-care/$memberCareId'
    | '/directory/peer-support/$peerSupportId'
    | '/directory/provider/$providerId'
    | '/user/profile/contact'
    | '/user/profile/demographics'
    | '/creator/profile/edit'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/contact-support'
    | '/privacy-policy'
    | '/terms-of-use'
    | '/_authenticated/_creator'
    | '/_authenticated/_directory'
    | '/_authenticated/_eula'
    | '/_authenticated/_explore'
    | '/_authenticated/_onboarding'
    | '/_authenticated/_organization'
    | '/_authenticated/_user'
    | '/creator/apply'
    | '/password-change/$authToken'
    | '/password-setup/$authToken'
    | '/forgot-password/'
    | '/login/'
    | '/sign-in/'
    | '/try-screener/'
    | '/verify-email/'
    | '/_authenticated/assessment/$assessmentId'
    | '/_authenticated/peer-support/weekly-report'
    | '/_authenticated/screener/$screenerId'
    | '/peer-support/weekly-report/$token'
    | '/try-screener/result/$'
    | '/_authenticated/settings/'
    | '/creator/apply/'
    | '/try-screener/$organizationSlug/'
    | '/_authenticated/_creator/creator/dashboard'
    | '/_authenticated/_creator/creator/library'
    | '/_authenticated/_eula/eula/update'
    | '/_authenticated/_explore/article/$contentId'
    | '/_authenticated/_explore/content/$slug'
    | '/_authenticated/_explore/loop/$contentId'
    | '/_authenticated/_onboarding/onboarding/organization'
    | '/_authenticated/_onboarding/onboarding/user'
    | '/_authenticated/_onboarding/onboarding/wholeness-screener'
    | '/_authenticated/_organization/organization/dashboard'
    | '/_authenticated/_organization/organization/roster'
    | '/_authenticated/_user/user/curated-content'
    | '/_authenticated/_user/user/dashboard'
    | '/_authenticated/_user/user/growth-zone'
    | '/content-creator/application/public/$token'
    | '/_authenticated/_explore/explore/'
    | '/_authenticated/peer-support/$/'
    | '/creator/apply/application/'
    | '/creator/apply/content-policy/'
    | '/creator/apply/form/'
    | '/creator/apply/preview/'
    | '/try-screener/$organizationSlug/screener/'
    | '/_authenticated/_creator/_content/creator/content'
    | '/_authenticated/_directory/_member-care/directory/member-care'
    | '/_authenticated/_directory/_peer-support/directory/peer-support'
    | '/_authenticated/_directory/_provider/directory/provider'
    | '/_authenticated/_explore/explore/creator/$userId'
    | '/_authenticated/_organization/organization/dashboard/peer-support'
    | '/_authenticated/_user/_profile/user/profile'
    | '/_authenticated/_creator/creator/profile/'
    | '/try-screener/$organizationSlug/screener/success/'
    | '/_authenticated/_creator/_content/creator/content/$contentId'
    | '/_authenticated/_creator/_content/creator/content/create'
    | '/_authenticated/_directory/_member-care/directory/member-care/$memberCareId'
    | '/_authenticated/_directory/_peer-support/directory/peer-support/$peerSupportId'
    | '/_authenticated/_directory/_provider/directory/provider/$providerId'
    | '/_authenticated/_user/_profile/user/profile/contact'
    | '/_authenticated/_user/_profile/user/profile/demographics'
    | '/_authenticated/_creator/creator/profile/edit/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ContactSupportRoute: typeof ContactSupportRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  TermsOfUseRoute: typeof TermsOfUseRoute
  CreatorApplyRoute: typeof CreatorApplyRouteWithChildren
  PasswordChangeAuthTokenRoute: typeof PasswordChangeAuthTokenRoute
  PasswordSetupAuthTokenRoute: typeof PasswordSetupAuthTokenRoute
  ForgotPasswordIndexRoute: typeof ForgotPasswordIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  SignInIndexRoute: typeof SignInIndexRoute
  TryScreenerIndexRoute: typeof TryScreenerIndexRoute
  VerifyEmailIndexRoute: typeof VerifyEmailIndexRoute
  PeerSupportWeeklyReportTokenRoute: typeof PeerSupportWeeklyReportTokenRoute
  TryScreenerResultSplatRoute: typeof TryScreenerResultSplatRoute
  TryScreenerOrganizationSlugIndexRoute: typeof TryScreenerOrganizationSlugIndexRoute
  ContentCreatorApplicationPublicTokenRoute: typeof ContentCreatorApplicationPublicTokenRoute
  TryScreenerOrganizationSlugScreenerIndexRoute: typeof TryScreenerOrganizationSlugScreenerIndexRoute
  TryScreenerOrganizationSlugScreenerSuccessIndexRoute: typeof TryScreenerOrganizationSlugScreenerSuccessIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ContactSupportRoute: ContactSupportRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  TermsOfUseRoute: TermsOfUseRoute,
  CreatorApplyRoute: CreatorApplyRouteWithChildren,
  PasswordChangeAuthTokenRoute: PasswordChangeAuthTokenRoute,
  PasswordSetupAuthTokenRoute: PasswordSetupAuthTokenRoute,
  ForgotPasswordIndexRoute: ForgotPasswordIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  SignInIndexRoute: SignInIndexRoute,
  TryScreenerIndexRoute: TryScreenerIndexRoute,
  VerifyEmailIndexRoute: VerifyEmailIndexRoute,
  PeerSupportWeeklyReportTokenRoute: PeerSupportWeeklyReportTokenRoute,
  TryScreenerResultSplatRoute: TryScreenerResultSplatRoute,
  TryScreenerOrganizationSlugIndexRoute: TryScreenerOrganizationSlugIndexRoute,
  ContentCreatorApplicationPublicTokenRoute:
    ContentCreatorApplicationPublicTokenRoute,
  TryScreenerOrganizationSlugScreenerIndexRoute:
    TryScreenerOrganizationSlugScreenerIndexRoute,
  TryScreenerOrganizationSlugScreenerSuccessIndexRoute:
    TryScreenerOrganizationSlugScreenerSuccessIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_authenticated",
        "/contact-support",
        "/privacy-policy",
        "/terms-of-use",
        "/creator/apply",
        "/password-change/$authToken",
        "/password-setup/$authToken",
        "/forgot-password/",
        "/login/",
        "/sign-in/",
        "/try-screener/",
        "/verify-email/",
        "/peer-support/weekly-report/$token",
        "/try-screener/result/$",
        "/try-screener/$organizationSlug/",
        "/content-creator/application/public/$token",
        "/try-screener/$organizationSlug/screener/",
        "/try-screener/$organizationSlug/screener/success/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/_creator",
        "/_authenticated/_directory",
        "/_authenticated/_eula",
        "/_authenticated/_explore",
        "/_authenticated/_onboarding",
        "/_authenticated/_organization",
        "/_authenticated/_user",
        "/_authenticated/assessment/$assessmentId",
        "/_authenticated/peer-support/weekly-report",
        "/_authenticated/screener/$screenerId",
        "/_authenticated/settings/",
        "/_authenticated/peer-support/$/"
      ]
    },
    "/contact-support": {
      "filePath": "contact-support.tsx"
    },
    "/privacy-policy": {
      "filePath": "privacy-policy.tsx"
    },
    "/terms-of-use": {
      "filePath": "terms-of-use.tsx"
    },
    "/_authenticated/_creator": {
      "filePath": "_authenticated/_creator.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_creator/creator/dashboard",
        "/_authenticated/_creator/creator/library",
        "/_authenticated/_creator/_content/creator/content",
        "/_authenticated/_creator/creator/profile/",
        "/_authenticated/_creator/creator/profile/edit/"
      ]
    },
    "/_authenticated/_directory": {
      "filePath": "_authenticated/_directory.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_directory/_member-care/directory/member-care",
        "/_authenticated/_directory/_peer-support/directory/peer-support",
        "/_authenticated/_directory/_provider/directory/provider",
        "/_authenticated/_directory/_member-care/directory/member-care/$memberCareId",
        "/_authenticated/_directory/_peer-support/directory/peer-support/$peerSupportId",
        "/_authenticated/_directory/_provider/directory/provider/$providerId"
      ]
    },
    "/_authenticated/_eula": {
      "filePath": "_authenticated/_eula.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_eula/eula/update"
      ]
    },
    "/_authenticated/_explore": {
      "filePath": "_authenticated/_explore.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_explore/article/$contentId",
        "/_authenticated/_explore/content/$slug",
        "/_authenticated/_explore/loop/$contentId",
        "/_authenticated/_explore/explore/",
        "/_authenticated/_explore/explore/creator/$userId"
      ]
    },
    "/_authenticated/_onboarding": {
      "filePath": "_authenticated/_onboarding.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_onboarding/onboarding/organization",
        "/_authenticated/_onboarding/onboarding/user",
        "/_authenticated/_onboarding/onboarding/wholeness-screener"
      ]
    },
    "/_authenticated/_organization": {
      "filePath": "_authenticated/_organization.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_organization/organization/dashboard",
        "/_authenticated/_organization/organization/roster",
        "/_authenticated/_organization/organization/dashboard/peer-support"
      ]
    },
    "/_authenticated/_user": {
      "filePath": "_authenticated/_user.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_user/user/curated-content",
        "/_authenticated/_user/user/dashboard",
        "/_authenticated/_user/user/growth-zone",
        "/_authenticated/_user/_profile/user/profile",
        "/_authenticated/_user/_profile/user/profile/contact",
        "/_authenticated/_user/_profile/user/profile/demographics"
      ]
    },
    "/creator/apply": {
      "filePath": "creator/apply.tsx",
      "children": [
        "/creator/apply/",
        "/creator/apply/application/",
        "/creator/apply/content-policy/",
        "/creator/apply/form/",
        "/creator/apply/preview/"
      ]
    },
    "/password-change/$authToken": {
      "filePath": "password-change/$authToken.tsx"
    },
    "/password-setup/$authToken": {
      "filePath": "password-setup/$authToken.tsx"
    },
    "/forgot-password/": {
      "filePath": "forgot-password/index.tsx"
    },
    "/login/": {
      "filePath": "login/index.tsx"
    },
    "/sign-in/": {
      "filePath": "sign-in/index.tsx"
    },
    "/try-screener/": {
      "filePath": "try-screener/index.tsx"
    },
    "/verify-email/": {
      "filePath": "verify-email/index.tsx"
    },
    "/_authenticated/assessment/$assessmentId": {
      "filePath": "_authenticated/assessment/$assessmentId.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/peer-support/weekly-report": {
      "filePath": "_authenticated/peer-support.weekly-report.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/screener/$screenerId": {
      "filePath": "_authenticated/screener/$screenerId.tsx",
      "parent": "/_authenticated"
    },
    "/peer-support/weekly-report/$token": {
      "filePath": "peer-support.weekly-report_.$token.tsx"
    },
    "/try-screener/result/$": {
      "filePath": "try-screener/result/$.tsx"
    },
    "/_authenticated/settings/": {
      "filePath": "_authenticated/settings/index.tsx",
      "parent": "/_authenticated"
    },
    "/creator/apply/": {
      "filePath": "creator/apply/index.tsx",
      "parent": "/creator/apply"
    },
    "/try-screener/$organizationSlug/": {
      "filePath": "try-screener/$organizationSlug/index.tsx"
    },
    "/_authenticated/_creator/creator/dashboard": {
      "filePath": "_authenticated/_creator/creator.dashboard.tsx",
      "parent": "/_authenticated/_creator"
    },
    "/_authenticated/_creator/creator/library": {
      "filePath": "_authenticated/_creator/creator.library.tsx",
      "parent": "/_authenticated/_creator"
    },
    "/_authenticated/_eula/eula/update": {
      "filePath": "_authenticated/_eula/eula.update.tsx",
      "parent": "/_authenticated/_eula"
    },
    "/_authenticated/_explore/article/$contentId": {
      "filePath": "_authenticated/_explore/article.$contentId.tsx",
      "parent": "/_authenticated/_explore"
    },
    "/_authenticated/_explore/content/$slug": {
      "filePath": "_authenticated/_explore/content.$slug.tsx",
      "parent": "/_authenticated/_explore"
    },
    "/_authenticated/_explore/loop/$contentId": {
      "filePath": "_authenticated/_explore/loop.$contentId.tsx",
      "parent": "/_authenticated/_explore"
    },
    "/_authenticated/_onboarding/onboarding/organization": {
      "filePath": "_authenticated/_onboarding/onboarding.organization.tsx",
      "parent": "/_authenticated/_onboarding"
    },
    "/_authenticated/_onboarding/onboarding/user": {
      "filePath": "_authenticated/_onboarding/onboarding.user.tsx",
      "parent": "/_authenticated/_onboarding"
    },
    "/_authenticated/_onboarding/onboarding/wholeness-screener": {
      "filePath": "_authenticated/_onboarding/onboarding.wholeness-screener.tsx",
      "parent": "/_authenticated/_onboarding"
    },
    "/_authenticated/_organization/organization/dashboard": {
      "filePath": "_authenticated/_organization/organization.dashboard.tsx",
      "parent": "/_authenticated/_organization"
    },
    "/_authenticated/_organization/organization/roster": {
      "filePath": "_authenticated/_organization/organization.roster.tsx",
      "parent": "/_authenticated/_organization"
    },
    "/_authenticated/_user/user/curated-content": {
      "filePath": "_authenticated/_user/user.curated-content.tsx",
      "parent": "/_authenticated/_user"
    },
    "/_authenticated/_user/user/dashboard": {
      "filePath": "_authenticated/_user/user.dashboard.tsx",
      "parent": "/_authenticated/_user"
    },
    "/_authenticated/_user/user/growth-zone": {
      "filePath": "_authenticated/_user/user.growth-zone.tsx",
      "parent": "/_authenticated/_user"
    },
    "/content-creator/application/public/$token": {
      "filePath": "content-creator/application/public/$token.tsx"
    },
    "/_authenticated/_explore/explore/": {
      "filePath": "_authenticated/_explore/explore.index.tsx",
      "parent": "/_authenticated/_explore"
    },
    "/_authenticated/peer-support/$/": {
      "filePath": "_authenticated/peer-support.$/index.tsx",
      "parent": "/_authenticated"
    },
    "/creator/apply/application/": {
      "filePath": "creator/apply/application/index.tsx",
      "parent": "/creator/apply"
    },
    "/creator/apply/content-policy/": {
      "filePath": "creator/apply/content-policy/index.tsx",
      "parent": "/creator/apply"
    },
    "/creator/apply/form/": {
      "filePath": "creator/apply/form/index.tsx",
      "parent": "/creator/apply"
    },
    "/creator/apply/preview/": {
      "filePath": "creator/apply/preview/index.tsx",
      "parent": "/creator/apply"
    },
    "/try-screener/$organizationSlug/screener/": {
      "filePath": "try-screener/$organizationSlug/screener/index.tsx"
    },
    "/_authenticated/_creator/_content/creator/content": {
      "filePath": "_authenticated/_creator/_content/creator.content.tsx",
      "parent": "/_authenticated/_creator",
      "children": [
        "/_authenticated/_creator/_content/creator/content/$contentId",
        "/_authenticated/_creator/_content/creator/content/create"
      ]
    },
    "/_authenticated/_directory/_member-care/directory/member-care": {
      "filePath": "_authenticated/_directory/_member-care/directory.member-care.tsx",
      "parent": "/_authenticated/_directory"
    },
    "/_authenticated/_directory/_peer-support/directory/peer-support": {
      "filePath": "_authenticated/_directory/_peer-support/directory.peer-support.tsx",
      "parent": "/_authenticated/_directory"
    },
    "/_authenticated/_directory/_provider/directory/provider": {
      "filePath": "_authenticated/_directory/_provider/directory.provider.tsx",
      "parent": "/_authenticated/_directory"
    },
    "/_authenticated/_explore/explore/creator/$userId": {
      "filePath": "_authenticated/_explore/explore.creator.$userId.tsx",
      "parent": "/_authenticated/_explore"
    },
    "/_authenticated/_organization/organization/dashboard/peer-support": {
      "filePath": "_authenticated/_organization/organization.dashboard_.peer-support.tsx",
      "parent": "/_authenticated/_organization"
    },
    "/_authenticated/_user/_profile/user/profile": {
      "filePath": "_authenticated/_user/_profile/user.profile.tsx",
      "parent": "/_authenticated/_user"
    },
    "/_authenticated/_creator/creator/profile/": {
      "filePath": "_authenticated/_creator/creator/profile/index.tsx",
      "parent": "/_authenticated/_creator"
    },
    "/try-screener/$organizationSlug/screener/success/": {
      "filePath": "try-screener/$organizationSlug/screener/success/index.tsx"
    },
    "/_authenticated/_creator/_content/creator/content/$contentId": {
      "filePath": "_authenticated/_creator/_content/creator.content.$contentId.tsx",
      "parent": "/_authenticated/_creator/_content/creator/content"
    },
    "/_authenticated/_creator/_content/creator/content/create": {
      "filePath": "_authenticated/_creator/_content/creator.content.create.tsx",
      "parent": "/_authenticated/_creator/_content/creator/content"
    },
    "/_authenticated/_directory/_member-care/directory/member-care/$memberCareId": {
      "filePath": "_authenticated/_directory/_member-care/directory.member-care_.$memberCareId.tsx",
      "parent": "/_authenticated/_directory"
    },
    "/_authenticated/_directory/_peer-support/directory/peer-support/$peerSupportId": {
      "filePath": "_authenticated/_directory/_peer-support/directory.peer-support_.$peerSupportId.tsx",
      "parent": "/_authenticated/_directory"
    },
    "/_authenticated/_directory/_provider/directory/provider/$providerId": {
      "filePath": "_authenticated/_directory/_provider/directory.provider_.$providerId.tsx",
      "parent": "/_authenticated/_directory"
    },
    "/_authenticated/_user/_profile/user/profile/contact": {
      "filePath": "_authenticated/_user/_profile/user.profile_.contact.tsx",
      "parent": "/_authenticated/_user"
    },
    "/_authenticated/_user/_profile/user/profile/demographics": {
      "filePath": "_authenticated/_user/_profile/user.profile_.demographics.tsx",
      "parent": "/_authenticated/_user"
    },
    "/_authenticated/_creator/creator/profile/edit/": {
      "filePath": "_authenticated/_creator/creator/profile/edit/index.tsx",
      "parent": "/_authenticated/_creator"
    }
  }
}
ROUTE_MANIFEST_END */
